import React from 'react';
import { WbMarkdownHtml } from '../../../utils/common';
import RectBoxPercentage from '../../rectbox';

const KeyResultRow = ({
  it, selectedItems, source, toggleChkBox, nested = false,
}) => (
  <div className="addKrModalRow">
    <div
      className="rectbox-col"
      style={{
        clear: 'both', width: '5%', float: 'left', paddingLeft: '2px',
      }}
    >
      <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp" style={{ marginTop: '4px', paddingLeft: `${nested ? '20px' : '0px'}` }}>
        <span style={{ cursor: 'pointer' }}>
          <div 
            id={`item-chk-${it.id}`}
            className={selectedItems.includes(it.id) ? 'icon icon-outline-check_box-18px' : 'icon icon-outline-check_box_outline_blank-18px'} 
            value={it.id} 
            onClick={(e) => toggleChkBox(e, it)} 
          />
        </span>
        <label className="css-label modalParaText" htmlFor={`item-chk-${source}-${it.id}`} />
      </div>
    </div>
    <div className="rectbox-col rectbox-kr-achive-col " style={{ float: 'left', width: '150px', marginTop: '4px' }}>
      <div className="" style={{ fontSize: '11px' }}>
        <span className="kr-achieve-target-text" style={{ color: it.progress_color, paddingLeft: `${nested ? '20px' : '0px'}` }}>
          {it.achieve_target_text}
        </span>
        {it.total_target_text !== '' ? (
          <span className="rectbox-subtitle">
            {` of ${it.total_target_text}`}
          </span>
        ) : '' }
      </div>
    </div>
    <div className="rectbox-col rectbox-col-goal rectbox-col-line" style={{ float: 'left', width: '60%', marginTop: '2px' }}>
      <div className="rectbox-metric-title" data-testid="rectbox-metric-title">
        {it.name}
      </div>
      <div
        className="rectbox-subtitle"
        style={{
          fontSize: '10px', textOverflow: 'ellipsis', wordWrap: 'break-word', overFlow: 'hidden',
        }}
      >
        <span dangerouslySetInnerHTML={WbMarkdownHtml(it.kr_owner ? it.kr_owner : '')} />
        {it.krQuarterDateText && (
          <>
            {it.kr_owner && <span className="dotClass" />}
            <span>{it.krQuarterDateText}</span>
          </>
        )}
      </div>
    </div>
  </div>
)
const KeyResultRows = ({
  item, toggleChkBox, source = 'krs-row-key', selectedItems = [],
}) => {
  const keyResults = [];
  item.metrics.forEach((it) => {
    keyResults.push(
      <KeyResultRow
        it={it}
        key={it.id}
        selectedItems={selectedItems}
        source={source}
        toggleChkBox={toggleChkBox}
      />,
    );
    // add nested KRs if any
    if (Array.isArray(it.nested_krs)) {
      it.nested_krs.forEach((nestedKR) => {
        keyResults.push(
          <KeyResultRow
            it={nestedKR}
            key={`${it.id}-${nestedKR.id}`}
            selectedItems={selectedItems}
            source={source}
            toggleChkBox={toggleChkBox}
            nested
          />,
        );
      });
    }
  });

  return (
    <div className="rectbox-row " style={{ display: 'inline-block', width: '95%' }}>
      <div className="rectbox-col" style={{ float: 'left' }}>
        <RectBoxPercentage count={item.goalProgress} style={{ color: item.getGoalProgressColor, borderRadius: '4px' }} showPercentage />
      </div>
      <div className="rectbox-col rectbox-col-goal rectbox-col-line okrBoxMargin" style={{ float: 'left' }}>
        <div className="rectbox-title"  data-testid="rectbox-title">
          {item.goalName}
        </div>
        <div className="rectbox-subtitle">
          {
            item.goalOwner
            && <span className="goal_owner_sec" title={item.goalOwner}>{item.goalOwner}</span>
          }
          {
            item.teamName
            && (
            <>
              {item.goalOwner && <span className="dotClass" />}
              <span className="goal_team_sec" title={item.teamName}>{item.teamName}</span>
            </>
            )
          }
          {
            item.goalTargetDate
            && (
            <>
              {(item.teamName || item.goalOwner) && <span className="dotClass" />}
              <span className="goal_date_sec">{item.goalTargetDate}</span>
            </>
            )
          }
        </div>
        { keyResults }
      </div>
    </div>
  )
};

export default KeyResultRows;
